module.exports = __webpack_public_path__ + "img/tuifang.514a705f.png";